// core
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// model
import {OrderStatus} from '../../../../core/models/order.model';
// service
import {OrdersStatusService} from '../../services/orders-status.service';
// store
import {OrderStore} from '../../../../core/stores/order.store';
// environments
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-orders-info-modal',
  templateUrl: './orders-info-modal.component.html',
  styleUrls: ['./orders-info-modal.component.scss']
})
export class OrdersInfoModalComponent implements OnInit {

  @Output() public close = new EventEmitter<boolean>();
  @Input() public currentOrder: OrderStatus;
  @Input() public locationId: string;
  @Input() public updateOrderStatus: (statusForUpdate: string, locationId: string, orderId: string) => void;

  public readonly isKitchen: boolean = environment.isKitchen;

  constructor(
    private orderStore: OrderStore,
    public ordersStatusService: OrdersStatusService
  ) {
  }

  ngOnInit() {
  }

  public closeModal() {
    this.close.emit(false);
  }

  public replacementStatus(statusForReplace: string): string {
    return this.ordersStatusService.replacementStatus(statusForReplace);
  }
  //
  public replacementStatusForActionButton(statusForReplace: string): string {
    return this.ordersStatusService.replacementStatusForActionButton(statusForReplace);
  }

  public addColorToStatus(currentStatus: string): string {
    return this.ordersStatusService.addColorToStatus(currentStatus);
  }
}

